import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Search, Filter } from "lucide-react";
// import { HeaderCompo } from "../../components/layout";
// import { getIssuedLogs, getLetterById } from "../../../Redux/Reducers/letterHeadReducer.ts";

// Material-UI imports
import {
  Box,
  TextField,
  InputAdornment,
  Select,
  MenuItem,
  FormControl,
  Typography,
  CircularProgress,
  Paper,
  Chip,
} from "@mui/material";
import { styled } from "@mui/material/styles";
// import { useLetterhead } from "./hooks/useLetterhead";
import { LetterViewModal } from "./components";
import { AuditLogTable } from "./components/audit/AuditLogTable.js";
import { getIssuedLogs, getLetterById } from "../../../Redux/Reducers/letterHeadReducer.ts";
import { useLetterhead } from "./hooks/useLetterhead.ts";
import { useUserDetailContext } from "../../../Components/UserDetailContext";

// ==========================================
// 🎨 Styled Components with inline styles
// ==========================================
const StyledSearchBox = styled(Box)(({ theme }) => ({
  position: "relative",
  "& .MuiTextField-root": {
    width: 250,
    "& .MuiOutlinedInput-root": {
      paddingLeft: 36,
      "& fieldset": {
        borderColor: "#e2e8f0",
      },
      "&:hover fieldset": {
        borderColor: "#94a3b8",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#3b82f6",
        borderWidth: 2,
      },
    },
    "& .MuiInputBase-input": {
      padding: "8px 16px 8px 0",
      fontSize: "0.875rem",
      backgroundColor: "white",
    },
  },
}));

const StyledFilterBox = styled(Box)(({ theme }) => ({
  position: "relative",
  "& .MuiFormControl-root": {
    minWidth: 170,
    "& .MuiOutlinedInput-root": {
      paddingLeft: 36,
      "& fieldset": {
        borderColor: "#e2e8f0",
      },
      "&:hover fieldset": {
        borderColor: "#94a3b8",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#3b82f6",
        borderWidth: 2,
      },
    },
    "& .MuiInputBase-input": {
      padding: "8px 32px 8px 0",
      fontSize: "0.875rem",
      fontWeight: 500,
      color: "#334155",
      backgroundColor: "white",
    },
    "& .MuiSelect-icon": {
      right: 8,
      color: "#94a3b8",
    },
  },
}));

// ==========================================
// 🔍 Extracted Components for Header Search & Filter
// ==========================================
const AuditLogSearch = ({ searchTerm, setSearchTerm }) => (
  <StyledSearchBox>
    <Box
      sx={{
        position: "absolute",
        left: 10,
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 1,
        color: "#94a3b8",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Search size={16} />
    </Box>
    <TextField
      type="text"
      placeholder="Search subjects or recipients..."
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      size="small"
      sx={{
        "& .MuiOutlinedInput-root": {
          backgroundColor: "white",
          boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
        },
      }}
    />
  </StyledSearchBox>
);

const AuditLogFilter = ({ statusFilter, setStatusFilter }) => (
  <StyledFilterBox>
    <Box
      sx={{
        position: "absolute",
        left: 10,
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 1,
        color: "#94a3b8",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Filter size={14} />
    </Box>
    <FormControl size="small">
      <Select
        value={statusFilter}
        onChange={(e) => setStatusFilter(e.target.value)}
        sx={{
          backgroundColor: "white",
          boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
          "& .MuiSelect-select": {
            paddingRight: "32px !important",
          },
        }}
      >
        <MenuItem value="ALL">All Records</MenuItem>
        <MenuItem value="SENT">Sent Only</MenuItem>
        <MenuItem value="DELETED">Deleted Only</MenuItem>
      </Select>
    </FormControl>
  </StyledFilterBox>
);

const AuditLogsPage = () => {
  const dispatch = useDispatch();

  const {
    issuedLogs,
    isLoading,
    selectedLetter,
    setSelectedLetter,
    templates,
  } = useLetterhead();

  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("ALL");
   const { userDetails } = useUserDetailContext();
  
  
    const userRefId = userDetails?.reference_id;

  

  useEffect(() => {
    dispatch(getIssuedLogs(userRefId));
  }, [dispatch]);

  const handleViewLetter = async (log) => {
    try {
      const actionResult = await dispatch(getLetterById(log.letter_id));
      const fullLetter = actionResult.payload?.data || actionResult.payload || log;
      setSelectedLetter(fullLetter);
    } catch (error) {
      console.error("Failed to fetch full letter details:", error);
      setSelectedLetter(log);
    }
  };

  const filteredLogs = (issuedLogs || []).filter((log) => {
    const subject = (log.subject || "").toLowerCase();
    const recipientName = (
      log.letter_recipients?.[0]?.name ||
      log.LetterRecipients?.[0]?.name ||
      ""
    ).toLowerCase();
    const searchLower = searchTerm.toLowerCase();
    const matchesSearch =
      subject.includes(searchLower) || recipientName.includes(searchLower);

    let matchesStatus = true;
    if (statusFilter === "DELETED") {
      matchesStatus = log.is_active === false || log.is_active === 0 || !log.is_active;
    } else if (statusFilter === "SENT") {
      matchesStatus = log.is_active === true || log.is_active === 1;
    }

    return matchesSearch && matchesStatus;
  });

  console.log("filteredLogsMMMMHN", filteredLogs, issuedLogs)

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100%" }}>
      {/* <HeaderCompo
        title="Issued Letters Audit Log"
        showSearchBar={true}
        SearchBarComponent={AuditLogSearch}
        searchProps={{ searchTerm, setSearchTerm }}
        showFilter={true}
        FilterComponent={AuditLogFilter}
        filterProps={{ statusFilter, setStatusFilter }}
      /> */}

      <Box
        sx={{
          px: 6,
          py: 8,
          maxWidth: "100%",
          mx: "auto",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
            mb: 8,
          }}
        >
          <Box>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                color: "#1e293b",
              }}
            >
              Audit Logs
            </Typography>
            <Typography
              variant="body2"
              sx={{
                mt: 2,
                color: "#64748b",
                maxWidth: "70%",
              }}
            >
              A permanent, immutable record of all official letters that have been
              successfully issued and verified by the system.
            </Typography>
          </Box>

          <Paper
            elevation={0}
            sx={{
              px: 4,
              py: 2,
              borderRadius: 2,
              border: "1px solid #e2e8f0",
              backgroundColor: "white",
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: "#64748b",
                fontWeight: 500,
              }}
            >
              Total Found:{" "}
              <Typography
                component="span"
                sx={{
                  color: "#0f172a",
                  fontWeight: 700,
                }}
              >
                {filteredLogs?.length || 0}
              </Typography>
            </Typography>
          </Paper>
        </Box>

        {isLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              py: 20,
            }}
          >
            <CircularProgress
              sx={{
                color: "#2563eb",
              }}
              size={40}
            />
          </Box>
        ) : (
          <AuditLogTable logs={filteredLogs} onView={handleViewLetter} />
        )}
      </Box>

      {selectedLetter && (
        <LetterViewModal
          letter={selectedLetter}
          onClose={() => setSelectedLetter(null)}
          template={templates?.find(
            (t) => String(t.template_id) === String(selectedLetter.template_id)
          )}
        />
      )}
    </Box>
  );
};

export default AuditLogsPage;